import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/discord-mini-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-3568f4bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-row shadow-md p-5 my-5 message rounded-md" }
const _hoisted_3 = { class: "w-4/5" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "w-1/5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mx-5 inline cursor-pointer",
  title: "Click to view in discord",
  alt: "Discord",
  src: _imports_0
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "flex flex-row shadow-md p-5 my-5 message rounded-md"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4/5" }, [
  /*#__PURE__*/_createElementVNode("div", null, "No messages to show")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "flex flex-row shadow-md p-5 my-5 message rounded-md"
}
const _hoisted_16 = {
  key: 0,
  class: "animate-spin -mr-1 ml-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "#000000",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-10" }, "Loading Insights...", -1))
const _hoisted_21 = {
  key: 3,
  class: "flex flex-row shadow-md p-5 my-5 message rounded-md"
}
const _hoisted_22 = { class: "w-4/5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalContainer = _resolveComponent("ModalContainer")!

  return (_openBlock(), _createBlock(_component_ModalContainer, {
    openImmediately: _ctx.isOpen,
    onClosed: _ctx.triggerClosed
  }, {
    modalTitle: _withCtx(() => [
      _createTextVNode("Message Insights Peek - " + _toDisplayString(_ctx.emotion), 1)
    ]),
    modalContent: _withCtx(() => [
      (_ctx.messagesToShow.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messagesToShow, (message) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_4, [
                        (message.authorUsername)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "@" + _toDisplayString(message.authorUsername), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, "@user-" + _toDisplayString(_ctx.messagex.userId), 1))
                      ]),
                      _createTextVNode(": " + _toDisplayString(message.rawText), 1)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(_ctx.isoToHumanReadableDate(message.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (/^\d+$/.test(message.channelId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("a", {
                            href: _ctx.getDiscordMessageLink(message),
                            target: "_blank"
                          }, _hoisted_11, 8, _hoisted_9),
                          _createTextVNode(" " + _toDisplayString((message.emotionScore * 100).toFixed(0)) + "% ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 256))
          ]))
        : (!_ctx.loading && _ctx.messagesToShow.length == 0 && !_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_19))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _hoisted_20
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.errorMessage), 1)
                ])
              ]))
    ]),
    _: 1
  }, 8, ["openImmediately", "onClosed"]))
}